import { createSlice } from '@reduxjs/toolkit';
import { Features } from '../../../featureToggles/features';
import { IAddEnterpriseSeatsState } from './interfaces';
import { addEnterpriseSeats } from './thunk';
import { BlockedByFeature, BlockedByFeatureType, notAvailablePropExceptIn } from '../../../featureToggles/features/utils';

export type IAddEnterpriseSeatsStateTrialsOfTiers = IAddEnterpriseSeatsState | BlockedByFeatureType;

const initialState: IAddEnterpriseSeatsStateTrialsOfTiers = notAvailablePropExceptIn({
  expected: {
    loading: false
  },
  availableIn: [Features.TrialsOfTiers]
});

const addEnterpriseSeatsSlice = createSlice({
  name: 'addEnterpriseSeats',
  initialState,
  reducers: {},
  extraReducers: {
    [addEnterpriseSeats?.pending.type]: (state: IAddEnterpriseSeatsStateTrialsOfTiers): IAddEnterpriseSeatsStateTrialsOfTiers => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = true;
      return state;
    },
    [addEnterpriseSeats?.fulfilled.type]: (state: IAddEnterpriseSeatsStateTrialsOfTiers): IAddEnterpriseSeatsStateTrialsOfTiers => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = false;
      return state;
    },
    [addEnterpriseSeats?.rejected.type]: (state: IAddEnterpriseSeatsStateTrialsOfTiers): IAddEnterpriseSeatsStateTrialsOfTiers => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = false;
      return state;
    }
  }
});

export default addEnterpriseSeatsSlice.reducer;
